/** Mentors for people new to a city: offering to help, finding one, requests, offers, introductions, safety. */
export const mentor = {
    "mentor.city.bengaluru": "Bengaluru",
    // Offering to help (asked in Talk)
    "mentor.offer_about": "Newcomers see your first name, work, languages, area and your own count of jobs. Never your phone number.",
    "mentor.listed": "Newcomers in {city} can find you.",
    // Finding a mentor
    "mentor.find": "Find a mentor",
    "mentor.find_about": "Someone who has worked in {city} for a while and can show you around. You choose who to ask. Nobody chooses for you.",
    "mentor.safety_title": "Before you meet anyone",
    "mentor.safety_public": "Meet in a public place.",
    "mentor.safety_money": "Never pay anyone for a job or a room through a mentor.",
    "mentor.safety_report": "Report anyone who asks you for money or documents.",
    "mentor.safety_ok": "I understand",
    "mentor.woman_ask": "Are you a woman? This stays on your phone. It lets you choose women mentors only.",
    "mentor.yes": "Yes",
    "mentor.no": "No",
    "mentor.women_only": "Women mentors only",
    "mentor.trade": "Work",
    "mentor.lang": "Language",
    "mentor.search": "Show mentors",
    "mentor.says": "Says {jobs} jobs over {months} months",
    "mentor.own_count": "This is their own phone's count.",
    "mentor.vouched": "Vouched for by {name}",
    "mentor.choose": "Choose {name}",
    "mentor.chosen": "Chosen",
    "mentor.max": "You can ask up to {count} at once.",
    "mentor.none": "No mentor yet",
    "mentor.none_women": "No woman mentor in {city} yet. You can switch off “Women mentors only”.",
    "mentor.none_intro": "Ask someone you know — a household you worked for, or your mentor — whether they know someone in {city}.",
    "mentor.helplines": "Numbers to save",
    // Asking
    "mentor.ask.one": "Ask {count} mentor",
    "mentor.ask.other": "Ask {count} mentors",
    "mentor.arrival": "Week you arrive",
    "mentor.area_near": "Area you will stay near (if you know)",
    "mentor.note": "A short note (if you like)",
    "mentor.send": "Send",
    "mentor.sent": "Asked. Their answers will show here.",
    "mentor.too_old": "{name} needs to update GigSync first.",
    "mentor.offers": "Mentors who can help you",
    "mentor.your_requests": "Your requests",
    "mentor.waiting": "Waiting for {name}…",
    "mentor.declined": "{name} can't help right now.",
    "mentor.closed": "Closed",
    "mentor.offered": "{name} can help you.",
    "mentor.accept_offer": "Accept {name}",
    "mentor.accept_help": "You can then message each other for 30 days. Either of you can renew it.",
    "mentor.cancel": "Cancel",
    "mentor.linked": "You and {name} can now message each other for 30 days.",
    // The mentor's side
    "mentor.requests": "Newcomers asking for help",
    "mentor.request_line": "{name} is moving to {city} for {trade} work, arriving the week of {date}.",
    "mentor.request_near": "Will stay near {area}.",
    "mentor.speaks": "Speaks {langs}",
    "mentor.help": "Help {name}",
    "mentor.not_now": "Not now",
    "mentor.offer_note": "A short note for them (if you like)",
    // Links
    "mentor.chip": "Mentor",
    "mentor.chip_newcomer": "New to the city",
    "mentor.days_left.one": "{count} day left",
    "mentor.days_left.other": "{count} days left",
    "mentor.renew": "Renew for 30 days",
    "mentor.renewed": "Open for 30 more days.",
    // Block and report
    "mentor.block": "Block",
    "mentor.block_confirm": "Block {name}? You will not see them anywhere on this phone, and GigSync will not match you again.",
    "mentor.blocked": "{name} is blocked.",
    "mentor.report": "Report",
    "mentor.report_title": "Report {name}",
    "mentor.reason.asked_money": "Asked me for money",
    "mentor.reason.asked_documents": "Asked for my documents",
    "mentor.reason.unsafe": "Made me feel unsafe",
    "mentor.reason.rude": "Was rude",
    "mentor.reason.other": "Something else",
    "mentor.report_send": "Send report",
    "mentor.reported": "Thank you. GigSync will look into it.",
    // Introductions
    "mentor.intro_ask": "Do you know someone in {city}?",
    "mentor.intro_ask_note": "I'm moving to {city}. Do you know someone there who could help me find my feet?",
    "mentor.intro_asked": "You asked {name}.",
    "mentor.introduce": "Introduce {name} to someone",
    "mentor.intro_pick": "Who should {name} meet in {city}?",
    "mentor.intro_send": "Introduce {name}",
    "mentor.intro_sent": "You introduced {name} and {other}.",
    "mentor.intro_none": "You can introduce people you signed a job with, or had a mentor link with.",
    "mentor.intro_got_mentor": "{by} wants you to meet {name}, who works in {city} and can help you.",
    "mentor.intro_got_newcomer": "{by} wants you to meet {name}, who is moving to {city} and could use your help.",
    "mentor.intro_meet": "Meet {name}",
    "mentor.intro_no": "No thanks",
    "mentor.intro_waiting": "Waiting for {name} to say yes…",
    "mentor.intros": "Introductions",
    "mentor.links": "Mentor links",
    "mentor.links_about": "Your mentor and the people you help. A link lasts 30 days unless one of you renews it.",
    "mentor.unread.one": "{count} new message",
    "mentor.unread.other": "{count} new messages",
    "mentor.placeholder": "Message {name}",
    "mentor.thread_empty": "Say hello to {name}.",
    "mentor.end": "End link",
    "mentor.end_confirm": "End your link with {name}? Your messages with them are deleted from this phone.",
    "mentor.ask_person": "Ask {name}",
    "mentor.no_people": "No one yet. People you sign a job with, or link with as a mentor, show here.",
};
//# sourceMappingURL=mentor.js.map